"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_RUMBLE: function() {
        return ADD_RUMBLE;
    },
    DELETE_RUMBLE: function() {
        return DELETE_RUMBLE;
    },
    DUPLICATE_RUMBLE: function() {
        return DUPLICATE_RUMBLE;
    },
    GENERATE_RUMBLES: function() {
        return GENERATE_RUMBLES;
    },
    RESET_RUMBLES: function() {
        return RESET_RUMBLES;
    },
    RUMBLE_COMPLETE: function() {
        return RUMBLE_COMPLETE;
    },
    RUMBLE_ELIMINATE: function() {
        return RUMBLE_ELIMINATE;
    },
    RUMBLE_ENTER: function() {
        return RUMBLE_ENTER;
    },
    RUMBLE_RESET: function() {
        return RUMBLE_RESET;
    },
    RUMBLE_START: function() {
        return RUMBLE_START;
    },
    UPDATE_RUMBLE: function() {
        return UPDATE_RUMBLE;
    }
});
const ADD_RUMBLE = "ADD_RUMBLE";
const UPDATE_RUMBLE = "UPDATE_RUMBLE";
const DELETE_RUMBLE = "DELETE_RUMBLE";
const GENERATE_RUMBLES = "GENERATE_RUMBLES";
const RESET_RUMBLES = "RESET_RUMBLES";
const DUPLICATE_RUMBLE = "DUPLICATE_RUMBLE";
const RUMBLE_ELIMINATE = "RUMBLE_ELIMINATE";
const RUMBLE_ENTER = "RUMBLE_ENTER";
const RUMBLE_START = "RUMBLE_START";
const RUMBLE_COMPLETE = "RUMBLE_COMPLETE";
const RUMBLE_RESET = "RUMBLE_RESET";
